import { convertIntoDashUSFormat } from "../../../../utilities/dateUtility";
import { displayDollar } from "../../../../utilities/tableUtility";
import { DefaultColumnOptions } from "../../../../hooks/useDataGrid/options";

const deliveryDateRenderer = (params) =>
  convertIntoDashUSFormat(params.value, false);

const tooltipDeliveryDateRenderer = (params) => (
  <div className="client-list-tooltip">
    {convertIntoDashUSFormat(params.value, false)}
  </div>
);

const amountRenderer = (params) => displayDollar(+params.value);

const tooltipAmountRenderer = (params) => (
  <div className="client-list-tooltip"> {displayDollar(+params.value)}</div>
);

export const Columns = [
  DefaultColumnOptions.Id,
  {
    headerName: "Status",
    field: "status",
    sortable: true,
    tooltipField: "status",
  },
  {
    headerName: "Due Date",
    field: "deliveryDate",
    sortable: true,
    sort: "desc",
    tooltipField: "deliveryDate",
    tooltipComponent: tooltipDeliveryDateRenderer,
    cellRenderer: deliveryDateRenderer,
  },
  {
    headerName: "Total Billing",
    field: "thresholdMakerSum",
    sortable: true,
    resizable: false,
    tooltipField: "thresholdMakerSum",
    tooltipComponent: tooltipAmountRenderer,
    cellRenderer: amountRenderer,
  },
  {
    headerName: "Payout",
    field: "amount",
    sortable: true,
    resizable: false,
    tooltipField: "amount",
    tooltipComponent: tooltipAmountRenderer,
    cellRenderer: amountRenderer,
  },
];
